import SubLabel from "components/Atoms/Sublabel";
import { VenuePreview } from "components/PreviewPanel/Venue/VenuePreviewPanel";
import React from "react";
import { RemovableLabel, RemovableProps } from "./Removable";

const RemovableVenue = (props: RemovableProps<server.dto.VenueSmall>) => {
  return <RemovableLabel {...props}>
    <div>
      <VenuePreview
        venueId={props.value.venueId}
        trigger={<a>{props.value.name}</a>}
      />
      <SubLabel>{props.value.cityCountry}</SubLabel>
    </div>
  </RemovableLabel>
};

export default RemovableVenue;